import { useRef } from 'react';
import { FormMethods } from '../types';
import { FormStore } from './form-store';

export const useForm = (form?: FormMethods) => {
  const formRef = useRef<FormMethods>();
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      const formStore = new FormStore();
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current] as [FormMethods];
};
